{
  "branding": {
    "frontdesk-attribution": "Obsługiwane przez FrontDesk+",
    "practice-logo": "Logo {{name}}"
  },
  "validation": {
    "required": "To pole jest wymagane",
    "invalid-url": "Proszę wprowadzić prawidłowy URL",
    "pin-too-short": "PIN musi mieć co najmniej 4 znaki",
    "pin-default-rejected": "Standardowy PIN 0000 jest niedozwolony. Proszę przypisać własny PIN.",
    "invalid-kim-address": "Please enter a valid KIM address (e.g. praxis@musterpraxis.kim.telematik)."
  },
  "common": {
    "back": "Wstecz",
    "next": "Dalej",
    "cancel": "Anuluj",
    "confirm": "Potwierdź",
    "done": "Gotowe",
    "retry": "Spróbuj ponownie",
    "clear": "Wyczyść",
    "close": "Zamknij",
    "verifying": "Weryfikacja...",
    "select": "Wybierz",
    "minutes": "minuty",
    "clock": "",
    "gender": {
      "M": "Mężczyzna",
      "W": "Kobieta",
      "D": "Różnorodne",
      "U": "Nieznane"
    },
    "insurance": {
      "GKV": "Ustawowe",
      "PKV": "Prywatne",
      "SELFPAY": "Samodzielna płatność"
    },
    "scroll-up": "Przewiń w górę",
    "scroll-down": "Przewiń w dół"
  },
  "settings": {
    "device-reset": {
      "title": "Zresetuj urządzenie",
      "description": "Usuń połączenie z gabinetem, ustawienia i kod PIN tego urządzenia.",
      "confirmation": "Urządzenie trzeba będzie skonfigurować ponownie. Konfiguracja SOL i dane pacjentów w inSuite pozostaną bez zmian.",
      "cancel": "Anuluj",
      "confirm": "Zresetuj teraz"
    },
    "title": "Ustawienia",
    "save": "Zapisz",
    "save-success": "Ustawienia zapisane",
    "save-error": "Nie udało się zapisać ustawień",
    "load-error": "Nie udało się załadować ustawień",
    "pin": {
      "title": "Wymagany PIN",
      "description": "Proszę wprowadzić PIN, aby uzyskać dostęp do ustawień.",
      "error": "Nieprawidłowy PIN. Spróbuj ponownie.",
      "backspace": "Usuń ostatnią cyfrę"
    },
    "connection": {
      "title": "Połączenie",
      "description": "Ustawienia połączenia dla serwera Doc-Cirrus Bridge",
      "bridge-url": "URL Bridge",
      "device-name": "Nazwa urządzenia",
      "device-name-placeholder": "np. Recepcja, pokój 1, kiosk",
      "device-name-hint": "Nazwa do identyfikacji w panelu kontrolnym Bridge",
      "kim-address": "Adres KIM (opcjonalnie)",
      "kim-address-placeholder": "praxis@musterpraxis.kim.telematik",
      "kim-address-hint": "This device only. Leave empty to use the practice KIM address.",
      "test": "Test",
      "success": "Połączenie udane",
      "error": "Połączenie nieudane",
      "api-unreachable": "Interfejs API DocCirrus jest nieosiągalny",
      "status-title": "Stan połączenia",
      "status": {
        "api": "API połączone",
        "ti": "Infrastruktura telematyczna",
        "card-reader": "Dostępny czytnik kart",
        "medical-card": "Karta gabinetu (SMC-B/HBA)"
      },
      "kim-address-consequence": "At Online Check-in the insurer sends the insured person’s data to this address instead of the practice address.",
      "kim-address-practice": "Practice address",
      "kim-address-confirm-title": "Change the KIM address for this device?",
      "kim-address-confirm-description": "At Online Check-in the insurer will send the insured person’s data to this address from now on.",
      "kim-address-confirm-previous": "Current",
      "kim-address-confirm-next": "New",
      "kim-address-confirm-cancel": "Cancel",
      "kim-address-confirm-accept": "Change address",
      "sol-token": "Token Sol (z inSuite)",
      "sol-token-hint": "Skopiuj z zarządzania Bridge w inSuite. Wymagany do połączenia.",
      "sol-token-show": "Pokaż token",
      "sol-token-hide": "Ukryj token",
      "bridge-unreachable": "Bridge jest nieosiągalny. Sprawdź adres i port.",
      "diagnostic-id": "ID diagnostyczne: {{id}}",
      "scan-qr": "Skanuj kod QR",
      "scan-title": "Skanuj kod QR Bridge",
      "scan-manual": "Wprowadź ręcznie"
    },
    "terminal": {
      "title": "Czytnik kart",
      "description": "Wybór czytnika kart dla infrastruktury telematycznej",
      "select": "Wybierz Terminal",
      "select-placeholder": "Wybierz terminal...",
      "loading": "Ładowanie terminali...",
      "none-available": "Brak dostępnych terminali",
      "none-found": "Nie znaleziono terminali",
      "found": "Znaleziono {{count}} terminal(i/ów)",
      "connect-hint": "Najpierw połącz się z serwerem bridge, aby załadować terminale.",
      "found-count": "Znalezione czytniki kart: {{count}}",
      "refresh": "Odśwież czytniki kart"
    },
    "practice": {
      "title": "Gabinet",
      "description": "Informacje o gabinecie",
      "name": "Nazwa gabinetu",
      "name-placeholder": "np. Dr Jan Kowalski",
      "welcome-message": "Wiadomość powitalna",
      "welcome-placeholder": "np. Witamy w naszym gabinecie",
      "scheduler-available": "Włącz harmonogram",
      "scheduler-available-description": "Pozwól pacjentom na rezerwację wizyt poprzez terminal samoobsługowy",
      "prescription-available": "Włącz usługę recepty",
      "prescription-available-description": "Patients can request repeat prescriptions at the self-service terminal. The practice reviews every request.",
      "welcome-hint": "Pozostaw puste, aby powitanie było w języku pacjenta. Własny tekst jest wyświetlany bez zmian we wszystkich językach."
    },
    "patient-info": {
      "eyebrow": "Patient information review",
      "description": "Applies practice-wide to every FrontDesk+ terminal and is enforced by the server.",
      "enabled": "Show the review after reading the health card",
      "phone": "Review telephone numbers",
      "email": "Review email addresses",
      "hausarzt": "Review primary physician",
      "selection-required": "Select at least one item to review.",
      "save": "Save review setting",
      "saved": "Review settings saved.",
      "conflict": "The setting changed in the meantime. The current version has been loaded.",
      "save-error": "The review settings could not be saved.",
      "unavailable": "The practice-wide setting is currently unavailable.",
      "scope": "Practice-wide · Server",
      "scope-description": "Stored on the practice server and enforced for all terminals.",
      "sentence-off": "The review is switched off. Patients are not asked about their contact details at the terminal.",
      "last-saved": "Last saved on the server: {{value}}",
      "never-saved": "Never saved on the server.",
      "last-saved-all": "Zapisano dla wszystkich urządzeń: {{value}}",
      "never-saved-default": "Ustawienie domyślne, jeszcze niezmienione."
    },
    "anamnesis": {
      "title": "Cyfrowa historia medyczna",
      "description": "Wyświetla link i QR code do dostawcy historii medycznej po zameldowaniu.",
      "enabled": "Pokaż link do historii choroby po zameldowaniu",
      "enabled-description": "Wyświetla link i QR code do dostawcy historii medycznej po zakończeniu meldowania, na przykład Nelly.",
      "url": "Link do dostawcy historii medycznej",
      "url-hint": "Link jest statyczny i identyczny dla wszystkich pacjentów.",
      "preview-label": "Podgląd ekranu zakończenia",
      "preview-note": "Link jest statyczny i identyczny dla wszystkich pacjentów.",
      "url-first": "Aby włączyć, najpierw wprowadź prawidłowy link."
    },
    "appearance": {
      "title": "Wygląd",
      "description": "Dostosuj interfejs użytkownika",
      "language": "Język",
      "default-kiosk-language": "Domyślny język pacjenta",
      "default-kiosk-language-hint": "Język, w którym rozpoczynają się nowe sesje kiosku dla pacjentów.",
      "voice-over-volume": "Głośność głosu",
      "voice-over-hint": "Kontroluje głośność asystenta lektora w celu zapewnienia dostępności.",
      "language-first": "Pokaż wybór języka na początku sesji"
    },
    "security": {
      "title": "Bezpieczeństwo",
      "description": "PIN do dostępu do ustawień",
      "pin": "PIN",
      "pin-hint": "4-8 digits. At least 4 digits, and not 0000."
    },
    "eyebrow": "Zarządzanie kioskiem",
    "nav": {
      "general": "Ogólne",
      "flows": "Funkcje",
      "anamnese": "Cyfrowy wywiad medyczny",
      "device": "Urządzenie i połączenie"
    },
    "flows": {
      "title": "Funkcje na terminalu"
    },
    "language": {
      "title": "Język i odczyt głosowy",
      "description": "Język i czytanie na głos dla pacjentów na tym urządzeniu."
    }
  },
  "self-service": {
    "title": "Samoobsługa",
    "step-progress": "Krok {{current}} / {{total}}",
    "flows": {
      "checkin": "Zameldowanie",
      "scheduler": "Umów wizytę",
      "prescription": "Recepty",
      "locations": "Mapa lokalizacji",
      "emergency": "Nagły wypadek"
    },
    "audio-guide": {
      "on": "Dźwięk włączony",
      "off": "Dźwięk wyłączony",
      "replay": "Powtórz wskazówki",
      "replay-unavailable": "Brak wskazówek głosowych do powtórzenia"
    },
    "language-selector": {
      "title": "Wybierz język",
      "description": "Wybierz preferowany język"
    },
    "settings": "Ustawienia",
    "start": {
      "welcome": "Witamy",
      "subtitle": "Proszę wybrać opcję",
      "check-in-label": "Ścieżka główna",
      "check-in-cta": "Zameldowanie",
      "check-in-description": "Masz już wizytę? Zamelduj się tutaj.",
      "check-in-hint": "Przygotuj kartę",
      "scheduler-label": "Nowy",
      "scheduler-cta": "Umów wizytę",
      "scheduler-description": "Zaplanuj nową wizytę.",
      "location-plan": "Mapa lokalizacji",
      "location-plan-description": "Znajdź drogę do gabinetu zabiegowego.",
      "prescription-label": "Recepta",
      "prescription-cta": "Recepty i zamawianie",
      "prescription-description": "Zobacz recepty lub zamów uzupełnienia.",
      "emergency-cta": "Lokalny alarm awaryjny",
      "emergency-description": "Słychać go tylko na tym urządzeniu; nie wzywa pomocy.",
      "tap-to-start": "Stuknij, aby rozpocząć"
    },
    "offline": {
      "banner-title": "Zameldowanie chwilowo niedostępne",
      "banner-message": "Prosimy o kontakt z personelem recepcji w celu uzyskania pomocy.",
      "emergency-available": "Lokalny alarm pozostaje dostępny. Nie wzywa pomocy.",
      "flow-disabled": "Chwilowo niedostępne"
    },
    "readability": {
      "toggle-label": "Tryb czytania",
      "on": "Tryb czytania",
      "off": "Tryb czytania"
    },
    "reset-overlay": {
      "timeout-title": "Sesja zakończona",
      "timeout-subtitle": "Twój czas minął. Twoje dane są bezpieczne.",
      "offline-title": "Utracono połączenie",
      "offline-subtitle": "Połączenie zostało przerwane. Proszę porozmawiać z personelem recepcji.",
      "interruption-title": "Sesja zakończona",
      "interruption-subtitle": "Twoja sesja została bezpiecznie zakończona.",
      "completion-title": "Dziękuję!",
      "completion-subtitle": "Twoje żądanie zostało zrealizowane pomyślnie.",
      "reassurance": "Twoje dane osobowe nie są przechowywane na tym urządzeniu.",
      "auto-dismiss": "Powrót do początku za {{seconds}} sekund...",
      "dismiss": "Przejdź do startu"
    },
    "timed-terminal": {
      "countdown": "Automatyczny powrót w ciągu {{seconds}} sekund",
      "countdown-outcome": "Ten terminal automatycznie powróci do ekranu startowego.",
      "more-time": "Więcej czasu",
      "extended": "Termin przedłużony"
    },
    "scheduler": {
      "questionnaire": {
        "language-unavailable": "Te pytania nie są dostępne w Twoim języku. Wybierz jeden z oferowanych języków lub zgłoś się do recepcji.",
        "alternatives": "Alternatywne terminy",
        "loading": "Ładowanie pytań…",
        "reception-fallback": "Proszę zgłosić się do recepcji.",
        "error-title": "Nie udało się wczytać pytań",
        "language-unavailable-lead": "Te pytania nie są dostępne w Pana/Pani języku.",
        "language-unavailable-title": "Proszę wybrać jeden z tych języków",
        "language-unavailable-body": "Albo poprosić o pomoc w recepcji."
      },
      "start": {
        "title": "Umów wizytę",
        "subtitle": "Umów preferowaną wizytę w kilku krokach",
        "welcome": "Witamy w systemie umawiania wizyt",
        "description": "Przeprowadzimy Cię przez proces umawiania",
        "cta": "Umów wizytę teraz"
      },
      "patient-id": {
        "title": "Identyfikacja",
        "subtitle": "Proszę się zidentyfikować",
        "mode-card": "Z kartą",
        "mode-search": "Szukaj",
        "mode-create": "Utwórz nowy",
        "insert-card": "Proszę włożyć kartę ubezpieczeniową",
        "reading-card": "Odczytywanie karty...",
        "simulate-card": "Symuluj kartę",
        "multiple-matches": "Znaleziono wielu pacjentów. Używanie danych z karty.",
        "search-placeholder": "Nazwisko lub numer ubezpieczenia...",
        "searching": "Wyszukiwanie...",
        "no-results": "Nie znaleziono wyników",
        "first-name": "Imię",
        "last-name": "Nazwisko",
        "dob": "Data urodzenia",
        "insurance": "Ubezpieczenie",
        "continue": "Kontynuuj",
        "creating": "Tworzenie pacjenta...",
        "patient-created": "Pacjent został utworzony pomyślnie!",
        "create-error": "Nie można utworzyć pacjenta."
      },
      "appointment-type": {
        "title": "Wybierz typ wizyty",
        "subtitle": "Proszę wybrać powód wizyty",
        "loading": "Ładowanie typów wizyt...",
        "no-types": "Brak dostępnych typów wizyt",
        "error": "Nie można załadować typów wizyt. Spróbuj ponownie.",
        "no-bookable": "Tych typów wizyt nie można obecnie zarezerwować w kiosku. Prosimy zgłosić się do recepcji lub umówić wizytę telefonicznie.",
        "disabled-default": "Prosimy umówić tę wizytę bezpośrednio w recepcji lub telefonicznie.",
        "disabled-footer": "Tylko recepcja/telefon",
        "lead": "Jaki rodzaj wizyty chce Pan/Pani zarezerwować?",
        "duration": "ok. {{minutes}} minut",
        "empty-title": "Obecnie nie można tu rezerwować wizyt",
        "none-bookable-title": "Tych wizyt nie można tu zarezerwować",
        "none-bookable-body": "Proszę zapytać w recepcji lub do nas zadzwonić."
      },
      "types": {
        "general": "Konsultacja ogólna",
        "general-desc": "Dla ogólnych dolegliwości i pytań",
        "checkup": "Badanie profilaktyczne",
        "checkup-desc": "Regularne badania zdrowotne",
        "vaccination": "Szczepienie",
        "vaccination-desc": "Zaplanuj szczepienie",
        "followup": "Wizyta kontrolna",
        "followup-desc": "Wizyta kontrolna",
        "prescription": "Recepta",
        "prescription-desc": "Odbiór recepty"
      },
      "slot-selection": {
        "title": "Wybierz wizytę",
        "subtitle": "Proszę wybrać dostępną wizytę",
        "loading": "Ładowanie dostępnych wizyt...",
        "no-slots": "Brak dostępnych wizyt",
        "no-appointment-type": "Nie wybrano typu wizyty",
        "error": "Nie można załadować dostępnych terminów. Spróbuj ponownie.",
        "quick-select": "Najbliższe dostępne wizyty:",
        "select-date": "Lub wybierz datę:",
        "times-for": "{{date}}",
        "available": "Dostępne",
        "unavailable": "Brak terminów",
        "slots": "terminy",
        "select-time-hint": "Dotknij godziny, aby umówić wizytę",
        "week-short": "Tydz",
        "weekday-mon": "Pon",
        "weekday-tue": "Wt",
        "weekday-wed": "Śr",
        "weekday-thu": "Czw",
        "weekday-fri": "Pt",
        "weekday-sat": "Sob",
        "weekday-sun": "Niedz",
        "period-morning": "Rano",
        "period-midday": "Południe",
        "period-afternoon": "Popołudnie",
        "period-evening": "Wieczór",
        "period-morning-short": "Rano",
        "period-midday-short": "Poł.",
        "period-afternoon-short": "Pop.",
        "period-evening-short": "Wiecz.",
        "period-dots-legend": "Dostępność czasowa",
        "filter-hint": "Filtruj według preferowanych godzin:",
        "or-choose-below": "lub wybierz poniżej",
        "no-slots-period": "Brak miejsc",
        "show-all": "Pokaż wszystko",
        "free": "bezpłatnie",
        "your-selection": "Twój wybór",
        "oclock": "godz",
        "choose-slot": "Wybierz miejsce",
        "choose-day": "Wybierz dzień",
        "choose-day-first": "Proszę najpierw wybrać dzień",
        "times-heading": "Wolne godziny {{date}}",
        "time-value": "{{time}}",
        "empty-title": "Brak wolnych terminów: {{month}}",
        "empty-body": "Proszę sprawdzić następny miesiąc lub zapytać w recepcji – chętnie pomożemy.",
        "next-month": "Następny miesiąc",
        "previous-month": "Poprzedni miesiąc"
      },
      "confirmation": {
        "patient-responses": "Twoje odpowiedzi",
        "review-loading": "Sprawdzanie podsumowania…",
        "review-unavailable": "Podsumowanie niedostępne. Proszę spróbować ponownie lub zapytać w recepcji.",
        "check-booking": "Sprawdź rezerwację",
        "title": "Potwierdź wizytę",
        "subtitle": "Proszę sprawdzić rezerwację",
        "patient": "Pacjent",
        "datetime": "Data i godzina",
        "booking": "Rezerwacja...",
        "confirm": "Umów wizytę",
        "heading": "Czy to wygląda dobrze?",
        "lead": "Prosimy o potwierdzenie terminu spotkania.",
        "appointment": "Umów się na spotkanie",
        "insured-via": "Ubezpieczony przez",
        "description-label": "Uwagi dla gabinetu (opcjonalnie)",
        "description-hint": "Daj nam znać, jeśli przy rezerwacji terminu lub rejestracji powinniśmy coś uwzględnić.",
        "description-placeholder": "np. ograniczona mobilność, osoba towarzysząca, ważne uwagi",
        "description-too-long": "Skróć uwagę do maksymalnie 500 znaków.",
        "summary": "Podsumowanie",
        "change": "Zmień",
        "book-binding": "Zarezerwuj wizytę",
        "cancel": "Anuluj",
        "type-label": "Rodzaj wizyty",
        "datetime-value": "{{date}}, godz. {{time}}",
        "name-label": "Imię i nazwisko",
        "insurance-label": "Ubezpieczenie",
        "insurance-GKV": "Ubezpieczenie ustawowe",
        "insurance-PKV": "Ubezpieczenie prywatne",
        "insurance-SELFPAY": "Płatność własna",
        "change-time": "Zmień termin",
        "description-free-text": "Inne uwagi (opcjonalnie)",
        "note-wheelchair": "Poruszam się na wózku",
        "note-companion": "Przyjdę z osobą towarzyszącą",
        "note-interpreter": "Potrzebuję tłumacza"
      },
      "done": {
        "title": "Wizyta umówiona!",
        "label": "Zarezerwowane",
        "subtitle": "Twoja wizyta została pomyślnie umówiona.",
        "date": "Data",
        "time": "Godzina",
        "booking-id": "Numer rezerwacji",
        "qr-hint": "Dodaj do kalendarza",
        "qr-description": "Zeskanuj ten kod QR aparatem smartfona, aby dodać wizytę do aplikacji kalendarza",
        "auto-redirect": "Za chwilę zostaniesz przekierowany na stronę startową...",
        "auto-redirect-countdown": "Powrót do startu za {{seconds}} sekund...",
        "back-to-start": "Powrót do startu",
        "print-button": "Drukuj potwierdzenie wizyty",
        "print-preparing": "Przygotowywanie widoku wydruku…",
        "print-error": "Nie udało się otworzyć potwierdzenia wizyty. Spróbuj ponownie lub poproś o pomoc w recepcji.",
        "print-returned": "Systemowy widok wydruku został zamknięty. W razie potrzeby możesz poprosić o kolejną kopię.",
        "print-title": "Twoja wizyta",
        "print-location": "Miejsce",
        "print-map-hint": "Otwórz miejsce w telefonie",
        "print-error-v2": "Nie udało się otworzyć potwierdzenia wizyty. Proszę spróbować ponownie lub zapytać w recepcji."
      },
      "error": {
        "assistance-info": "Nie udało się potwierdzić rezerwacji. Wizyta może być już zarezerwowana. Proszę zapytać w recepcji.",
        "pending-title": "Rezerwacja niepotwierdzona",
        "pending-info": "Nie udało się potwierdzić rezerwacji. Wizyta może być już zarezerwowana. Proszę sprawdzić ponownie lub zapytać w recepcji.",
        "title": "Rezerwacja nieudana",
        "subtitle": "Nie można umówić wizyty.",
        "info": "Proszę spróbować ponownie lub zapytać w recepcji."
      },
      "phase": {
        "identify": "Zameldowanie",
        "choose": "Wybór terminu",
        "confirm": "Potwierdzenie"
      }
    },
    "prescription": {
      "start": {
        "title": "Recepty i zamawianie",
        "subtitle": "Włóż swoją kartę ubezpieczeniową, aby przeglądać recepty lub zamawiać uzupełnienia.",
        "button": "Włóż kartę"
      },
      "card-check": {
        "loading": "Ładowanie czytnika kart...",
        "no-terminal": "Nie skonfigurowano czytnika kart",
        "no-terminal-hint": "Prosimy o kontakt z personelem w celu uzyskania pomocy.",
        "insert-card": "Proszę włożyć kartę",
        "insert-card-hint": "Włóż kartę ubezpieczeniową do czytnika kart.",
        "card-detected": "Wykryto kartę",
        "reading": "Czytanie karty...",
        "reading-hint": "Proszę chwilę poczekać.",
        "error": "Błąd odczytu karty",
        "retry": "Spróbuj ponownie",
        "manual-lookup": "Kontynuuj bez karty",
        "load-error": "Nie można załadować czytnika kart",
        "read-error": "Nie udało się odczytać karty"
      },
      "patient-selection": {
        "title": "Wybierz pacjenta",
        "subtitle": "Znaleziono wielu pacjentów. Wybierz swoje imię i nazwisko.",
        "try-again": "Spróbuj ponownie",
        "try-again-hint": "Włóż kartę ponownie"
      },
      "list": {
        "title": "Twoje recepty",
        "for-patient": "Recepty na {{name}}",
        "loading": "Ładowanie recept...",
        "error-title": "Błąd ładowania",
        "fetch-error": "Nie można wczytać recept",
        "back-home": "Powrót do początku",
        "done": "Gotowe"
      },
      "detail": {
        "prescription-info": "Informacje dotyczące recepty",
        "date": "Data",
        "prescriber": "Lekarz przepisujący",
        "comment": "Uwaga",
        "medications": "Leki",
        "form": "Formularz",
        "pack-size": "Wielkość opakowania",
        "manufacturer": "Producent",
        "loading": "Ładowanie recepty...",
        "fetch-error": "Nie można wczytać szczegółów recepty",
        "back-to-list": "Powrót do listy",
        "print": "Drukuj"
      },
      "types": {
        "public": "Recepta publiczna",
        "private": "Recepta prywatna",
        "long-term": "Recepta długoterminowa",
        "btm": "Recepta na narkotyki",
        "g": "Zielona Recepta",
        "t": "T-Recepta"
      },
      "no-patient": {
        "title": "Nie znaleziono pacjenta",
        "subtitle": "Niestety, nie znaleziono pacjenta dla tej karty. Aby uzyskać pomoc, skontaktuj się z personelem.",
        "try-again": "Spróbuj ponownie",
        "back-home": "Powrót do początku",
        "title-v2": "Nie znaleziono pasujących danych",
        "subtitle-v2": "Nie udało się Pana/Pani znaleźć. Proszę spróbować ponownie lub zapytać w recepcji."
      },
      "done": {
        "title": "Dziękuję",
        "subtitle": "Możesz już usiąść. W razie pytań prosimy o kontakt z personelem.",
        "no-prescriptions-title": "Brak recept w aktach",
        "no-prescriptions-subtitle": "Nie znaleźliśmy dla Ciebie żadnych aktywnych recept. Jeśli się tego spodziewałeś, skontaktuj się z obsługą recepcji.",
        "error-title": "Wystąpił błąd",
        "error-subtitle": "Prosimy o kontakt z personelem w celu uzyskania dalszej pomocy.",
        "auto-redirect": "Automatyczne przekierowanie w ciągu {{seconds}} sekund",
        "finish": "Powrót do początku"
      },
      "hub": {
        "title": "Twoje recepty",
        "for-patient": "Recepty na {{name}}",
        "loading": "Ładowanie recept...",
        "error-title": "Błąd ładowania",
        "fetch-error": "Nie można wczytać recept",
        "back-home": "Powrót do początku",
        "done": "Gotowe",
        "order-button": "Zamów Receptę",
        "existing-prescriptions": "Twoje aktualne recepty",
        "no-prescriptions": "Nie znaleziono aktywnych recept."
      },
      "patient-lookup": {
        "title": "Znajdź pacjenta",
        "subtitle": "Podaj swoje imię i nazwisko oraz datę urodzenia.",
        "last-name": "Nazwisko",
        "first-name": "Imię",
        "date-of-birth": "Data urodzenia",
        "lastname": "Nazwisko",
        "lastname-placeholder": "Twoje nazwisko",
        "firstname": "Imię",
        "firstname-placeholder": "Twoje imię",
        "dob": "Data urodzenia",
        "search": "Szukaj",
        "searching": "Wyszukiwanie...",
        "search-error": "Błąd wyszukiwania: {{message}}",
        "no-match": "Nie znaleziono pacjenta. Sprawdź swoje dane.",
        "error": "Błąd wyszukiwania. Spróbuj ponownie.",
        "found": "Znaleziono pacjenta",
        "confirm": "Potwierdź",
        "ambiguous": "Wiele dopasowań",
        "ambiguous-hint-firstname": "Aby zawęzić wyszukiwanie, wpisz także swoje imię.",
        "ambiguous-hint-additional": "Proszę sprawdzić swoje dane lub skontaktować się z personelem.",
        "not-found": "Nie znaleziono pacjenta",
        "not-found-hint": "Nie udało się znaleźć żadnego pacjenta z tymi danymi.",
        "not-found-action": "Spróbuj ponownie"
      },
      "manual-identification": {
        "unverified": "Twoja tożsamość nie została potwierdzona kartą ubezpieczenia zdrowotnego. Przychodnia sprawdzi dane i prośbę przed jej przetworzeniem."
      },
      "medication-selection": {
        "title": "Poproś o receptę",
        "subtitle": "Gabinet sprawdza Twoją prośbę. Po zatwierdzeniu eRx będzie gotowe w aplikacji e-prescription.",
        "back": "Wróć",
        "submit": "Kontynuuj przeglądanie",
        "reason-title": "Dlaczego potrzebujesz recepty?",
        "reason-hint": "Pomaga gabinetowi ocenić Twoją prośbę.",
        "reason-validation": "Wybierz powód.",
        "reason-schmerzen": "Ból",
        "reason-entzuendung": "Zapalenie",
        "reason-nachsorge": "Po zabiegu zabieg /",
        "reason-allergie": "Reakcja alergiczna /",
        "reason-chronisch": "Stan przewlekły",
        "reason-anderes": "Coś innego",
        "medications-title": "Jakie leki?",
        "request-hint": "Opisz, czego potrzebujesz lub podaj poprzednią receptę, którą chcesz odnowić.",
        "request-placeholder": "np. Ibuprofen 600 mg, tak samo jak ostatnim razem",
        "request-validation": "Proszę opisać, jakiego leku potrzebujesz.",
        "history-title": "Poprzednie recepty",
        "history-hint": "Dodaj wpis, aby wstępnie wypełnić żądanie.",
        "history-loading": "Ładowanie poprzednich recept...",
        "history-error": "Poprzednie recepty nie mogły zostać wczytane.",
        "history-add": "Dodaj",
        "history-added": "Dodano",
        "history-date": "Ostatni: {{date}}",
        "history-request-line": "Odnów: {{medicationName}}",
        "urgency-title": "Jak pilne jest to zadanie?",
        "urgency-hint": "Pomaga gabinetowi ustalić priorytet.",
        "urgency-soon": "Pilne",
        "urgency-soon-meta": "Jak najszybciej",
        "urgency-tomorrow": "Wkrótce",
        "urgency-tomorrow-meta": "W ciągu najbliższych kilku dni",
        "urgency-week": "W tym tygodniu",
        "urgency-week-meta": "Brak presji czasu",
        "lead": "Gabinet sprawdzi Pana/Pani wniosek. Po zatwierdzeniu e-recepta będzie dostępna w aplikacji e-recepty lub na karcie ubezpieczenia.",
        "history-hint-v2": "Proszę dotknąć wcześniejszej recepty, aby ją dodać.",
        "history-retry": "Wczytaj ponownie"
      },
      "request-review": {
        "title": "Sprawdź zamówienie",
        "subtitle": "Proszę zapoznać się z prośbą o receptę.",
        "request-label": "Żądane leki",
        "selected-medications": "Wybrane leki",
        "free-text-medications": "Dodatkowe leki",
        "freetext-label": "Inne",
        "quarterly-warning": "Twoja karta ubezpieczenia nie została odczytana w tym kwartale. Gabinet może się z Tobą skontaktować.",
        "egk-warning": "Twoja karta ubezpieczenia nie została odczytana w tym kwartale. Gabinet może się z Tobą skontaktować.",
        "submit": "Prześlij",
        "submitting": "Przesyłanie...",
        "submit-error": "Nie można przesłać żądania. Spróbuj ponownie.",
        "back": "Wróć",
        "reason-label": "Powód",
        "urgency-label": "Pilna sprawa",
        "completion-email-choice": "Chcę otrzymać e-mail, gdy gabinet rozpatrzy moją prośbę.",
        "completion-email-label": "Adres e-mail",
        "completion-email-placeholder": "nazwa@przyklad.pl",
        "completion-email-hint": "Tylko do tej jednorazowej wiadomości. Adres nie zostanie zapisany w danych podstawowych.",
        "completion-email-invalid": "Wprowadź prawidłowy adres e-mail.",
        "egk-proof-required": "Wnioski o receptę są dostępne tylko po pomyślnym odczycie karty ubezpieczenia. Prosimy zgłosić się do personelu.",
        "title-v2": "Sprawdź wniosek",
        "completion-email-hint-v2": "Adres zostanie użyty tylko do tej jednej wiadomości."
      },
      "confirmation": {
        "title": "Żądanie wysłane",
        "subtitle": "Twoja prośba o receptę została pomyślnie przesłana.",
        "success-title": "Żądanie wysłane",
        "success-subtitle": "Twoja prośba o receptę została pomyślnie przesłana.",
        "estimated-time": "Twoja recepta będzie gotowa za około {{time}}.",
        "info": "Receptę możesz odebrać w aptece za pomocą karty ubezpieczeniowej lub aplikacji eRezept.",
        "auto-redirect": "Automatyczne przekierowanie w ciągu {{seconds}} sekund",
        "back-to-start": "Powrót do początku",
        "handling-label": "Handled by the practice",
        "next-steps": "Gabinet sprawdzi Pana/Pani wniosek. Po zatwierdzeniu e-receptę można zrealizować w aptece kartą ubezpieczenia lub w aplikacji e-recepty."
      },
      "phase": {
        "identify": "Zameldowanie",
        "request": "Wniosek",
        "review": "Sprawdzenie"
      }
    },
    "check-in": {
      "flow-label": "Zameldowanie",
      "has-appointment": {
        "eyebrow": "Spotkanie",
        "title": "Czy masz wizytę?",
        "subtitle": "Proszę wybrać opcję",
        "yes-label": "Tak",
        "yes": "Tak, mam wizytę",
        "yes-description": "Chcę się zameldować na wizytę.",
        "yes-hint": "Najszybsza ścieżka",
        "unsure-label": "Może",
        "unsure": "Nie jestem pewien",
        "unsure-description": "Sprawdzimy to za Ciebie.",
        "unsure-hint": "Będziemy Cię szukać",
        "no-label": "Nie",
        "no": "Nie, bez wizyty",
        "no-description": "Nie mam wizyty.",
        "no-hint": "Wejście"
      },
      "card-check": {
        "eyebrow": "Karta ubezpieczenia",
        "title": "Odczytaj kartę ubezpieczeniową",
        "subtitle": "Proszę włożyć kartę ubezpieczeniową do czytnika",
        "insert-title": "Włóż kartę ubezpieczenia zdrowotnego do czytnika.",
        "insert-detail": "Twoje dane odczytujemy automatycznie – nie musisz nic więcej robić.",
        "other-ways": "Inne sposoby",
        "no-card-hint": "Jeśli nie masz teraz przy sobie karty.",
        "pkv-hint": "Korzystaj z QR code w swojej aplikacji ubezpieczeniowej.",
        "loading": "Ładowanie ustawień...",
        "no-terminal": "Brak skonfigurowanego czytnika kart. Skontaktuj się z personelem.",
        "checking": "Sprawdzanie kart...",
        "insert-prompt": "Proszę włożyć kartę...",
        "card-detected": "Wykryto kartę! Gotowa do odczytu.",
        "read-card": "Odczytaj kartę",
        "simulate-insert": "Symuluj kartę",
        "reading": "Odczytywanie karty...",
        "error": "Nie można odczytać karty. Spróbuj ponownie.",
        "read-error": "Nie udało się odczytać danych z karty. Spróbuj ponownie.",
        "settings-error": "Nie można załadować ustawień. Spróbuj ponownie.",
        "no-card-prompt": "Nie masz karty?",
        "no-card-action": "Wyszukiwanie ręczne",
        "connection-warning": "Problemy z połączeniem z czytnikiem kart. Proszę czekać...",
        "pkv-prompt": "Ubezpieczenie prywatne? Online Check-in",
        "pkv-instruction": "Zeskanuj ten QR code za pomocą aplikacji prywatnego ubezpieczenia zdrowotnego, aby przesłać swoje dane cyfrowo.",
        "pkv-continue": "Kontynuuj rejestrację ręczną",
        "unreadable-title": "Card detected, but no insurance data could be read.",
        "unreadable-body": "Please try again or go to the reception desk. You can also check in without your card.",
        "unreadable-help": "Spróbuj ponownie lub zgłoś się bez karty. Recepcja chętnie pomoże.",
        "title-pkv": "Zgłoszenie przez aplikację",
        "title-reading": "Karta jest odczytywana …",
        "title-unreadable": "Nie udało się odczytać karty",
        "title-no-terminal": "Zgłoszenie bez karty",
        "no-terminal-body": "Czytnik kart jest teraz niedostępny. Zgłoś się bez karty lub zwróć się do recepcji.",
        "reading-detail": "Proszę zostawić kartę w czytniku. To potrwa tylko chwilę.",
        "other-ways-title": "Inne możliwości",
        "no-card-title": "Zgłoś się bez karty",
        "pkv-prompt-title": "Ubezpieczenie prywatne?",
        "pkv-prompt-hint": "Zgłoszenie przez aplikację prywatnego ubezpieczenia zdrowotnego",
        "pkv-close": "Jednak z kartą",
        "pkv-instruction-app": "Otwórz aplikację swojego prywatnego ubezpieczenia zdrowotnego i zeskanuj ten kod. Twoje dane trafią wtedy bezpośrednio do nas."
      },
      "patient-selection": {
        "title": "Wybierz pacjenta",
        "subtitle": "Znaleziono wielu pacjentów. Proszę wybrać siebie.",
        "firstname-label": "Twoje imię",
        "firstname-placeholder": "Podaj imię...",
        "confirm-button": "Potwierdź",
        "no-match": "Nie znaleziono pasującego pacjenta. Proszę udać się do recepcji po pomoc.",
        "still-ambiguous": "Pozostało wiele dopasowań. Proszę udać się do recepcji po pomoc.",
        "select-error": "Nie udało się zidentyfikować pacjenta. Spróbuj ponownie.",
        "staff-assist": "Idź do recepcji",
        "title-v2": "Krótkie pytanie",
        "subtitle-v2": "Dla bezpieczeństwa wpisz swoje imię.",
        "no-match-v2": "Nie znaleźliśmy Cię z tym imieniem. Sprawdź pisownię lub zwróć się do recepcji.",
        "still-ambiguous-v2": "Nie udało się jeszcze jednoznacznie Cię znaleźć. Zwróć się do recepcji.",
        "select-error-v2": "Niestety się nie udało. Spróbuj ponownie."
      },
      "card-checkin": {
        "title": "Potwierdź zameldowanie",
        "subtitle": "Twoje dane zostały pomyślnie odczytane.",
        "confirm": "Potwierdź zameldowanie"
      },
      "register-from-card": {
        "title": "Nowa rejestracja",
        "subtitle": "Nie jesteś jeszcze w naszym systemie. Czy chcesz się zarejestrować?",
        "card-data": "Dane karty",
        "create": "Zarejestruj się",
        "create-error": "Rejestracja nie powiodła się. Spróbuj ponownie lub poproś personel o pomoc.",
        "staff-assist": "Zadzwoń do personelu",
        "no-card-data-title": "Brak danych karty",
        "no-card-data": "Nie można odczytać danych z Twojej karty.",
        "insurance-verified": "Ubezpieczenie zweryfikowane: {{insurer}}",
        "insurer-missing": "The card does not contain a cost-carrier identifier. Registration via the card is not possible. Please go to the reception desk.",
        "title-v2": "Twoje dane z karty",
        "subtitle-v2": "Sprawdź swoje dane. Jeśli coś się nie zgadza, dotknij „Zmień”.",
        "create-v2": "Potwierdź dane",
        "create-error-v2": "Zgłoszenie niestety się nie udało. Spróbuj ponownie lub zwróć się do recepcji.",
        "insurer-missing-v2": "Na Twojej karcie brakuje informacji o kasie chorych. Zwróć się do recepcji.",
        "edit": "Zmień",
        "name": "Imię i nazwisko",
        "insurer": "Kasa chorych"
      },
      "patient-lookup": {
        "title": "Wyszukaj pacjenta",
        "subtitle": "Proszę wprowadzić nazwisko lub numer ubezpieczenia.",
        "lastname": "Nazwisko",
        "lastname-placeholder": "Twoje nazwisko",
        "dob": "Data urodzenia",
        "firstname": "Imię",
        "firstname-placeholder": "Twoje imię",
        "search": "Szukaj",
        "searching": "Wyszukiwanie...",
        "search-placeholder": "Nazwisko lub numer ubezpieczenia...",
        "results-placeholder": "Wyniki wyszukiwania pojawią się tutaj",
        "found": "Znaleziono pacjenta!",
        "confirm-identity": "Proszę potwierdzić, że jesteś wskazanym pacjentem.",
        "confirm-button": "To ja",
        "ambiguous-firstname": "Znaleziono wielu pacjentów. Proszę wpisać swoje imię.",
        "ambiguous-additional": "Znaleziono wielu pacjentów. Prosimy o kontakt z personelem.",
        "disambiguation-hint": "Dzięki temu możemy Cię wyraźnie zidentyfikować.",
        "not-found": "Nie znaleziono żadnego pacjenta posiadającego te dane.",
        "error": "Błąd wyszukiwania: {{message}}",
        "staff-assist": "Zadzwoń do personelu",
        "not-found-prompt": "Nie znaleziono?",
        "register-new": "Zarejestruj nowego",
        "not-found-hint": "No patient could be found with these details.",
        "create-new": "Register new patient",
        "dob-placeholder": "DD.MM.YYYY",
        "dob-picker": "Choose date of birth in the calendar",
        "title-v2": "Zgłoszenie bez karty",
        "subtitle-firstname": "Wpisz dodatkowo swoje imię.",
        "ambiguous-firstname-v2": "Jest kilka osób o tym nazwisku. Wpisz dodatkowo swoje imię.",
        "search-again": "Szukaj ponownie",
        "found-v2": "Znaleźliśmy Cię",
        "found-confirm": "Potwierdź przyciskiem „To ja”.",
        "not-found-title": "Nie znaleźliśmy Cię",
        "not-found-check": "Sprawdź pisownię i datę urodzenia. Recepcja chętnie pomoże.",
        "not-found-reception": "Sprawdź pisownię i datę urodzenia lub zwróć się do recepcji.",
        "ambiguous-additional-v2": "Nie udało się jednoznacznie Cię znaleźć. Zwróć się do recepcji.",
        "error-v2": "Wyszukiwanie teraz się nie udało. Spróbuj ponownie."
      },
      "checking-in": {
        "title": "Chwileczkę – meldujemy Cię.",
        "subtitle": "Dodajemy Cię do kolejki leczenia i powiadamiamy zespół.",
        "step-insurance": "Ubezpieczenie sprawdzone",
        "step-appointment": "Wizyta potwierdzona",
        "step-waitlist": "Dodanie do listy oczekujących",
        "error": "Zameldowanie nie powiodło się. Spróbuj ponownie.",
        "continue": "Kontynuuj mimo to",
        "title-v2": "Chwileczkę",
        "loading": "Zgłaszamy Cię …",
        "subtitle-v2": "Wpisujemy Cię na listę oczekujących i informujemy zespół.",
        "error-title": "Niestety się nie udało",
        "error-v2": "Nie udało się zakończyć zgłoszenia.",
        "error-body": "Spróbuj ponownie. Jeśli znowu się nie uda, pomoże recepcja."
      },
      "appointment-selection": {
        "title": "Wybierz spotkanie",
        "subtitle": "Masz dzisiaj kilka spotkań. Proszę wybrać jeden.",
        "checking-in": "Meldowanie się...",
        "time": "{{time}}",
        "error-v2": "Zgłoszenie na tę wizytę się nie udało. Spróbuj ponownie lub zwróć się do recepcji."
      },
      "no-appointment": {
        "title": "Nie znaleziono spotkania",
        "subtitle": "Nie mogliśmy dzisiaj znaleźć dla Ciebie terminu. Prosimy o rezerwację stałego terminu.",
        "book-appointment": "Zarezerwuj wizytę",
        "book-appointment-description": "Zarezerwuj nową wizytę poprzez zwykły terminarz.",
        "staff-assist": "Zadzwoń do personelu",
        "staff-assist-description": "Potrzebuję pomocy.",
        "booking-disabled": "Appointment booking is currently unavailable",
        "booking-disabled-description": "Please contact the practice team to arrange an appointment.",
        "back-to-start": "Back to start",
        "subtitle-v2": "Nie znaleźliśmy dziś dla Ciebie żadnej wizyty.",
        "book-v2": "Umów nową wizytę",
        "book-v2-description": "Wybierz teraz wolny termin.",
        "have-appointment": "Mam umówioną wizytę",
        "have-appointment-description": "Recepcja chętnie pomoże.",
        "unavailable-title": "Wizyty umawia się w recepcji",
        "subtitle-unavailable": "Nie znaleźliśmy dziś dla Ciebie żadnej wizyty. Zwróć się do recepcji."
      },
      "staff-assist": {
        "title": "Powiadomiony personel",
        "subtitle": "Pracownik wkrótce Ci pomoże.",
        "message": "Proszę czekać tutaj. Wkrótce dołączy do Ciebie pracownik.",
        "start-over": "Powrót do początku",
        "auto-redirect": "Powrót do początku za {{seconds}} sekund..."
      },
      "eeb-prompt": {
        "title": "Zweryfikuj ubezpieczenie",
        "title-failed": "Weryfikacja nieudana",
        "subtitle": "Jak chcesz zweryfikować swoje ubezpieczenie?",
        "subtitle-failed": "Zeskanuj kod QR aplikacją ubezpieczeniową, aby zażądać weryfikacji.",
        "verify-card": "Zweryfikuj elektronicznie",
        "verify-card-description": "Wyślij żądanie do swojego ubezpieczyciela.",
        "select-insurer": "Wybierz ubezpieczyciela",
        "select-insurer-description": "Ręczny wybór ubezpieczyciela.",
        "skip": "Pomiń",
        "eyebrow-chip": "Alternatywa",
        "eyebrow": "Odprawa · dowód ubezpieczenia (eEB)",
        "recommended": "Zalecane",
        "qr-title": "Zeskanuj za pomocą aplikacji ubezpieczeniowej",
        "qr-description": "Otwórz aplikację ubezpieczenia zdrowotnego i zeskanuj kod — eEB zostanie wysłany bezpośrednio do nas.",
        "qr-address-label": "Wyślij do",
        "title-app": "Potwierdzenie przez aplikację",
        "subtitle-app": "Twoja kasa chorych może też przesłać nam potwierdzenie bezpośrednio. Gdy skończysz, dotknij „Dalej”."
      },
      "quarterly-check": {
        "title": "Weryfikacja ubezpieczenia",
        "checking": "Sprawdzamy Twoją aktualną weryfikację ubezpieczenia...",
        "error": "Nie można przeprowadzić sprawdzenia.",
        "title-v2": "Twoje ubezpieczenie",
        "checking-v2": "Sprawdzamy Twoje ubezpieczenie – chwileczkę.",
        "error-body": "Twoje zgłoszenie jest zakończone. Kwestię ubezpieczenia wyjaśni z Tobą recepcja."
      },
      "insurer-prefilled": {
        "title": "Twoje ubezpieczenie zdrowotne",
        "subtitle": "Proszę potwierdzić swoje ubezpieczenie na ten kwartał.",
        "your-insurance": "Twoje ubezpieczenie",
        "last-read": "Ostatnia weryfikacja {{date}}",
        "quarterly-notice": "Do celów rozliczeniowych potrzebujemy aktualnego potwierdzenia ubezpieczenia na ten kwartał.",
        "confirm-button": "Tak, to jest moje ubezpieczenie",
        "change-button": "Mam inne ubezpieczenie",
        "contact-title": "Poproś o elektroniczny dowód ubezpieczenia",
        "contact-description": "Zadzwoń do swojego ubezpieczyciela i poproś o elektroniczny dowód ubezpieczenia:",
        "contact-patient": "Pacjent",
        "contact-kim-address": "Adres KIM gabinetu",
        "contact-phone": "Phone",
        "question": "Czy to Twoja kasa chorych?",
        "quarterly-notice-v2": "Raz na kwartał potrzebujemy potwierdzenia z Twojej kasy chorych."
      },
      "insurer-search": {
        "title": "Wybierz ubezpieczenie zdrowotne",
        "subtitle": "Proszę wyszukać i wybrać swoje ustawowe ubezpieczenie zdrowotne.",
        "placeholder": "Szukaj ubezpieczenia...",
        "hint": "Wprowadź co najmniej 2 znaki, aby wyszukać.",
        "no-results": "Nie znaleziono ubezpieczenia.",
        "no-results-hint": "Sprawdź pisownię lub spróbuj innego wyszukiwania.",
        "label": "Nazwa Twojej kasy chorych",
        "search-error-v2": "Wyszukiwanie teraz się nie udało. Spróbuj ponownie.",
        "app-alternative": "Wolisz aplikację swojej kasy chorych?"
      },
      "insurer-contact": {
        "title": "Poproś o dowód ubezpieczenia",
        "subtitle": "Proszę wybrać jedną z poniższych opcji.",
        "or": "lub",
        "option-eeb-title": "Zapytanie drogą elektroniczną",
        "option-eeb-description": "Jeżeli zachodzi ustawowy przypadek wyjątkowy, po wyrażeniu zgody możesz przekazać zgłoszenie zespołowi praktyki.",
        "option-qr-title": "Skanuj za pomocą aplikacji",
        "option-qr-description": "Zeskanuj QR code za pomocą aplikacji ubezpieczeniowej.",
        "option-call-title": "Zadzwoń do siebie",
        "option-call-description": "Zadzwoń do swojego ubezpieczyciela i poproś o eEB dla tego gabinetu:",
        "phone": "Phone",
        "phone-not-available": "Numer telefonu podany na karcie ubezpieczenia",
        "patient-name": "Pacjent",
        "practice-kim": "Adres KIM gabinetu",
        "help-notice": "W razie problemów zapraszamy do recepcji.",
        "submit-eeb-button": "Zapytaj teraz",
        "contacted-button": "Zadzwoniłem",
        "contacted-button-countdown": "Czas na Twoje połączenie ({{seconds}}s)",
        "go-to-counter-button": "Idź do recepcji",
        "qr-continue-button": "Przeskanowałem",
        "qr-continue-button-countdown": "Czas skanowania ({{seconds}}s)",
        "title-v2": "Potwierdzenie z Twojej kasy chorych",
        "subtitle-v2": "Najprościej przez aplikację Twojej kasy chorych.",
        "subtitle-no-app": "Wybierz, jak Twoja kasa chorych ma przesłać nam potwierdzenie.",
        "option-eeb-description-v2": "Zapytamy Twoją kasę chorych za Ciebie. Do tego potrzebujemy Twojej zgody.",
        "call-instruction": "Zadzwoń do kasy chorych i poproś o przesłanie potwierdzenia do naszego gabinetu.",
        "call-instruction-practice": "Zadzwoń do kasy chorych i poproś o przesłanie potwierdzenia do gabinetu {{practice}}.",
        "done-button": "Gotowe – dalej",
        "done-button-countdown": "Gotowe – dalej (jeszcze {{seconds}} s)"
      },
      "eeb-consent": {
        "title": "Zgoda",
        "subtitle": "Potrzebujemy Twojej zgody na elektroniczną weryfikację ubezpieczenia.",
        "insurance": "Twoje ubezpieczenie",
        "consent-title": "Zgoda na elektroniczną weryfikację ubezpieczenia (eEB)",
        "consent-text": "Rozumiem, że moja kasa chorych przekaże moje dane ubezpieczeniowe (np. imię i nazwisko, datę urodzenia, numer ubezpieczenia) przez bezpieczną usługę komunikacji KIM do gabinetu {{practiceName}} jako potwierdzenie ubezpieczenia. Wyrażam zgodę na tę transmisję. Wiem, że mogę wycofać tę zgodę w dowolnym momencie bez wpływu na moje leczenie.",
        "withdrawal-notice": "Możesz w każdej chwili cofnąć tę zgodę.",
        "agree-button": "Zgadzam się",
        "decline-button": "Anuluj",
        "treatment-notice": "Twoje leczenie nie jest uzależnione od tej zgody.",
        "load-failed": "The consent details could not be loaded. You can scan the QR code with your insurer app instead.",
        "not-available": "This request is not possible here right now. Please speak to reception.",
        "submit-failed": "Your consent could not be saved. Please try again or speak to reception.",
        "title-v2": "Potwierdzenie z Twojej kasy chorych",
        "summary": "Twoja kasa chorych przesyła nam potwierdzenie bezpośrednio. Do tego potrzebujemy Twojej zgody.",
        "confirm-first": "Najpierw potwierdź oświadczenie."
      },
      "qr-code": {
        "title": "Zeskanuj aplikacją ubezpieczeniową",
        "instruction-1": "Otwórz aplikację ubezpieczeniową i zeskanuj ten kod QR.",
        "instruction-2": "Gabinet automatycznie otrzyma wtedy potwierdzenie ubezpieczenia.",
        "practice": "Gabinet: {{name}}",
        "alternative-hint": "Alternatywa: Użyj aplikacji ubezpieczeniowej",
        "instruction-app": "Otwórz aplikację swojej kasy chorych i zeskanuj ten kod. Potwierdzenie trafi wtedy bezpośrednio do nas.",
        "staff-line": "Dla zespołu gabinetu: {{address}}",
        "staff-line-practice": "Dla zespołu gabinetu: {{name}} · {{address}}",
        "alternative-app": "Możesz też poprosić o potwierdzenie przez aplikację kasy chorych: otwórz aplikację i zeskanuj ten kod."
      },
      "register-basics": {
        "title": "Dane osobowe",
        "subtitle": "Proszę wprowadzić swoje dane.",
        "family-name": "Nazwisko",
        "given-name": "Imię",
        "dob": "Data urodzenia",
        "gender": "Płeć",
        "insurance-type": "Typ ubezpieczenia",
        "insurer-name": "Nazwa Twojego ubezpieczenia",
        "insurer-name-placeholder": "np. Debeka, DKV, Allianz...",
        "gender-required": "Wybierz jedną opcję."
      },
      "register-insurer": {
        "title": "Ubezpieczenie zdrowotne",
        "subtitle": "Proszę wybrać swoje ubezpieczenie zdrowotne.",
        "search-placeholder": "Szukaj ubezpieczenia..."
      },
      "register-details": {
        "title": "Podsumowanie",
        "subtitle": "Proszę sprawdzić swoje informacje.",
        "create": "Zakończ rejestrację",
        "missing-data": "Proszę wypełnić wszystkie wymagane pola.",
        "create-error": "Rejestracja nie powiodła się. Spróbuj ponownie.",
        "policy-number": "Numer polisy (opcjonalnie)",
        "policy-number-placeholder": "Numer Twojej polisy",
        "create-v2": "Zakończ zgłoszenie",
        "policy-number-hint": "Numer znajdziesz na karcie swojego ubezpieczenia."
      },
      "diff-review": {
        "eyebrow-chip": "Recenzja",
        "eyebrow": "Zameldowanie · dane karty",
        "title": "Porównanie danych",
        "subtitle": "Znaleziono różnice między danymi z karty a naszymi zapisami.",
        "col-current": "Aktualny zapis",
        "col-new": "Nowość z kard",
        "new-badge": "nowy",
        "field-fallback": "Pole",
        "note": "Zaktualizowane dane pomagają nam prawidłowo wystawiać rachunki i docierać do Ciebie w nagłych przypadkach.",
        "comparison-placeholder": "Porównanie zostanie pokazane tutaj",
        "confirm": "Potwierdź zmiany",
        "apply-error": "Nie można zastosować danych. Spróbuj ponownie.",
        "retry": "Spróbuj ponownie",
        "skip": "Kontynuuj mimo to",
        "no-changes": "Nie znaleziono zmian",
        "title-v2": "Twoje dane się zmieniły",
        "subtitle-v2": "Na Twojej karcie są nowsze dane. Czy mamy je przejąć?",
        "confirm-v2": "Przejmij i zgłoś",
        "keep": "Zgłoś bez zmian",
        "col-current-v2": "Dotychczas",
        "col-new-v2": "Nowe z karty",
        "value-yes": "Tak",
        "value-no": "Nie"
      },
      "insurance-selection": {
        "title": "Typ ubezpieczenia",
        "subtitle": "Proszę wybrać typ ubezpieczenia.",
        "gkv": "Ubezpieczony ustawowo",
        "gkv-description": "Członek ustawowego ubezpieczenia zdrowotnego.",
        "pkv": "Prywatne lub samodzielna płatność",
        "pkv-description": "Ubezpieczony prywatnie lub samodzielna płatność.",
        "pkv-description-v2": "Prywatne ubezpieczenie zdrowotne lub płacisz sam."
      },
      "eeb-request": {
        "title": "Zgłoszenie zarejestrowane",
        "subtitle": "Możesz zakończyć rejestrację. Odpowiedź od {{insurer}} dotrze do praktyki później.",
        "verifying": "Twoje zgłoszenie zostało przyjęte do natychmiastowego przetworzenia.",
        "success": "Twoje zgłoszenie zostało bezpiecznie przekazane zespołowi praktyki.",
        "error": "Potwierdzenie zgłoszenia jest niedostępne.",
        "try-alternative": "Metoda alternatywna",
        "kim-load-error": "Nie udało się wczytać adresu KIM gabinetu.",
        "kim-label": "Gabinet · KIM",
        "non-blocking-note": "To jeszcze nie potwierdza wpłynięcia do Twojej kasy chorych ani Twojego statusu ubezpieczenia.",
        "auto-continue": "Za {{seconds}} sekund nastąpi automatyczne przejście dalej.",
        "unavailable-title": "Niestety się nie udało",
        "unavailable-v2": "Nie udało się zapisać Twojego wniosku do kasy chorych.",
        "unavailable-body": "Możesz poprosić o potwierdzenie przez aplikację kasy chorych albo załatwić to w recepcji.",
        "use-app": "Przez aplikację",
        "at-reception": "Załatw w recepcji"
      },
      "self-pay": {
        "title": "Samodzielna płatność",
        "subtitle": "Będziesz traktowany jako pacjent z samodzielną płatnością.",
        "info": "Pamiętaj, że będziesz odpowiedzialny za koszty leczenia.",
        "confirm": "Rozumiem",
        "title-v2": "Płacisz sam",
        "subtitle-v2": "Płacisz za leczenie sam.",
        "insured-after-all": "Jednak jestem ubezpieczony"
      },
      "done": {
        "title": "Gotowe!",
        "subtitle": "Twoje zameldowanie jest zakończone.",
        "finish": "Zakończ",
        "done-label": "Gotowe",
        "error-label": "Uwaga",
        "eyebrow": "Zameldowanie · zakończone",
        "queue-label": "Poczekalnia",
        "queue-title": "Proszę usiąść",
        "queue-meta": "Zadzwonimy do Ciebie osobiście.",
        "success-title": "Zameldowanie udane!",
        "success-subtitle": "Proszę usiąść w poczekalni. Zostaniesz wezwany.",
        "auto-redirect": "Za chwilę zostaniesz przekierowany na stronę startową...",
        "auto-redirect-countdown": "Powrót do początku za {{seconds}} sekund...",
        "card-expired-title": "Karta wygasła",
        "card-expired-subtitle": "Twoja karta ubezpieczeniowa wygasła.",
        "card-expired-info": "Skontaktuj się z personelem w celu uzyskania pomocy.",
        "back-to-start": "Powrót do startu",
        "anamnesis-title": "Wypełnij formularz historii choroby",
        "anamnesis-description": "Zeskanuj QR code, aby wygodnie wypełnić formularz historii medycznej na swoim smartfonie.",
        "title-confirm": "Thank you!",
        "subtitle-confirm": "You have confirmed your details. Your check-in is complete — please take a seat in the waiting room.",
        "title-saved": "Thank you!",
        "subtitle-saved": "Your changes have been processed. Reception will get in touch if anything is open. Please take a seat in the waiting room.",
        "title-skip": "Skipped",
        "subtitle-skip": "No problem — your check-in is complete. You can tell reception about changes at any time.",
        "title-v2": "Jesteś zgłoszony",
        "card-expired-info-v2": "Zwróć się do recepcji."
      },
      "patient-info": {
        "loading": "Loading your contact details …",
        "review": {
          "title": "Review contact details",
          "intro": "Are these details still correct? The review is voluntary — your check-in is already complete.",
          "no-contacts": "No telephone numbers or email addresses are on file.",
          "all-correct": "Everything is correct",
          "skip": "Skip",
          "primary": "Primary",
          "protected": "Reception will review any change to this contact.",
          "reveal": "Show",
          "hide": "Hide",
          "type": {
            "MOBILEPRIV": "Mobile (private)",
            "PHONEPRIV": "Phone (private)",
            "MOBILEJOB": "Mobile (work)",
            "PHONEJOB": "Phone (work)",
            "EMAILPRIV": "Email (private)",
            "EMAILJOB": "Email (work)"
          },
          "save": "Save",
          "save-failed": "Could not save — please speak to reception.",
          "delete": "Delete",
          "undo": "Undo",
          "invalid": "Please check the format.",
          "add": "Add",
          "add-title": "Add a contact",
          "add-type": "Type",
          "add-value": "Enter a value",
          "hausarzt": "Family doctor / GP",
          "hausarzt-placeholder": "Enter a name or practice",
          "hausarzt-reception": "Reception will review any change to this information.",
          "hausarzt-invalid": "Enter no more than 120 characters.",
          "category": {
            "phone": "Phone",
            "email": "Email",
            "hausarzt": "Family doctor"
          },
          "category-empty": "Not on file",
          "primary-tag": "Main contact",
          "protected-chip": "Protected — reception reviews",
          "chip-direct": "Changes: saved directly",
          "chip-reception": "Changes: reception reviews",
          "chip-staged_one": "{{count}} change pending",
          "chip-staged_other": "{{count}} changes pending",
          "chip-will-add": "Will be added",
          "expand-phone_one": "Show {{count}} more number",
          "expand-phone_other": "Show {{count}} more numbers",
          "expand-email_one": "Show {{count}} more address",
          "expand-email_other": "Show {{count}} more addresses",
          "collapse-phone_one": "Hide additional number",
          "collapse-phone_other": "Hide additional numbers",
          "collapse-email_one": "Hide additional address",
          "collapse-email_other": "Hide additional addresses",
          "change": "Change",
          "close": "Close",
          "staged-removal": "Will be removed — value hidden",
          "stage-add": "Add to list",
          "add-more-phone": "Add another number",
          "add-more-email": "Add another address",
          "invalid-phone": "Please enter a valid phone number.",
          "invalid-email": "Please enter a valid email address.",
          "hausarzt-previous": "previously: {{value}}",
          "hausarzt-counter": "{{count}} / 120",
          "balance-total_one": "{{count}} change",
          "balance-total_other": "{{count}} changes",
          "balance-direct": "{{count}} saved directly",
          "balance-reception": "{{count}} reviewed by reception",
          "proposal-open": "Suggest a new address",
          "proposal-placeholder": "Your suggestion",
          "proposal-discard": "Discard",
          "proposal-hint": "Your suggestion goes to reception — the address is not changed immediately.",
          "title-v2": "Sprawdź swoje dane",
          "balance-prefix": "Przy zapisie:",
          "balance-direct-v2": "Zapisane od razu: {{count}}",
          "balance-reception-v2": "Sprawdza recepcja: {{count}}",
          "chip-reception-v2": "Zmiany sprawdza nasza recepcja",
          "chip-changed": "Zmieniono: {{count}}",
          "remove": "Usuń",
          "example-email": "np. imie@przyklad.pl",
          "example-phone": "np. 512 345 678",
          "intro-v2": "Twoje zgłoszenie jest zakończone. Czy te dane są nadal aktualne? Sprawdzenie jest dobrowolne.",
          "auto-hide": "Pokazane wartości po chwili znów zostaną ukryte."
        },
        "result": {
          "title": "Result",
          "continue": "Continue",
          "outcome": {
            "updated": "Updated",
            "satisfied": "Was already up to date",
            "task-created": "Sent to reception",
            "not-saved": "Not saved yet",
            "pending-retry": "Not saved yet"
          },
          "retry": "Try again",
          "removed": "Was removed",
          "cleared": "Was cleared",
          "task-note": "Nothing was overwritten — reception will get in touch if needed.",
          "not-saved-note": "Nothing was overwritten. Please speak to reception.",
          "banner-unfinished": "One detail has not been saved yet. You can try again directly on that row.",
          "banner-done": "Your details have been processed.",
          "footer": "All other details remain unchanged.",
          "task-note-v2": "Przekazaliśmy tę informację do recepcji.",
          "banner-done-v2": "Dziękujemy! Otrzymaliśmy Twoje dane.",
          "footer-v2": "Wszystkie inne dane pozostają bez zmian."
        },
        "expiry": {
          "notice": "For data protection reasons the review ends in 2 minutes. Your check-in stays complete.",
          "title": "The review has expired",
          "body": "For data protection reasons all displayed and entered values were deleted. Your check-in is still complete — you do not need to repeat anything. You can tell reception about changes at any time.",
          "continue": "To the summary",
          "body-v2": "Ze względu na ochronę danych zamknęliśmy widok. Twoje zgłoszenie jest mimo to zakończone. Zmiany możesz zawsze zgłosić w recepcji."
        }
      },
      "progress": {
        "identify": "Zgłoszenie",
        "insurance": "Ubezpieczenie",
        "done": "Gotowe"
      },
      "dob-format-hint": "Na przykład 01.10.1980",
      "dob-required": "Wpisz swoją datę urodzenia.",
      "insurance-label": {
        "GKV": "Ubezpieczenie ustawowe",
        "PKV": "Ubezpieczenie prywatne",
        "SELFPAY": "Płatność własna"
      }
    },
    "emergency": {
      "title": "Nagła sytuacja!",
      "label": "Nagły wypadek",
      "subtitle": "Ten alarm jest słyszalny tylko lokalnie i nie wezwał pomocy. W nagłym lub potencjalnie zagrażającym życiu przypadku zadzwoń pod 112.",
      "call-emergency": "Zadzwoń do służb ratunkowych (112)",
      "stop-sound": "Zatrzymaj dźwięk",
      "play-sound": "Odtwórz dźwięk",
      "back-to-start": "Powrót do początku",
      "headline": "Proszę natychmiast zwrócić się do personelu w recepcji. W razie zagrożenia życia proszę dzwonić pod 112."
    },
    "help-reception": "Pomoc w recepcji",
    "help-reception-toast": "Prosimy o kontakt z recepcją. Chętnie pomożemy.",
    "language-entry": {
      "title": "Wybierz język"
    },
    "loading": "Ładowanie…",
    "step-progress-label": "Postęp",
    "step-progress-phase": "Sekcja {{current}} z {{total}}: {{phase}}",
    "step-progress-substep": "Część {{current}} z {{total}}",
    "step-progress-complete": "Zakończono",
    "identification": {
      "title": "Kim Pan/Pani jest?",
      "lead": "Najszybciej z kartą ubezpieczenia zdrowotnego. Można też wyszukać po nazwisku.",
      "lead-card-only": "Proszę włożyć kartę ubezpieczenia zdrowotnego do czytnika kart.",
      "mode-label": "Jak chce się Pan/Pani zameldować?",
      "mode-card": "Kartą",
      "mode-search": "Szukaj po nazwisku",
      "mode-create": "Nowy pacjent",
      "card": {
        "loading": "Przygotowywanie czytnika kart …",
        "checking": "Sprawdzanie czytnika kart …",
        "insert-title": "Proszę włożyć kartę ubezpieczenia zdrowotnego do czytnika kart.",
        "insert-detail": "Odczytujemy dane automatycznie.",
        "detected": "Karta rozpoznana",
        "read": "Odczytaj kartę",
        "reading": "Odczytywanie karty …",
        "reading-hint": "Proszę nie wyjmować karty.",
        "no-terminal-title": "Czytnik kart niedostępny",
        "help-with-search": "Proszę wyszukać po nazwisku lub zapytać w recepcji.",
        "help-reception": "Proszę zapytać w recepcji – chętnie pomożemy.",
        "unreadable-title": "Karta rozpoznana, ale nieczytelna",
        "error-title": "Nie udało się odczytać karty",
        "not-unique": "Nie udało się jednoznacznie przypisać karty. Proszę wyszukać po nazwisku lub zapytać w recepcji.",
        "no-match": "Nie znaleźliśmy danych dla tej karty. Proszę wyszukać po nazwisku lub zapytać w recepcji.",
        "without-card": "Dalej bez karty"
      },
      "lookup": {
        "lead": "Proszę podać nazwisko i datę urodzenia.",
        "first-name": "Imię",
        "last-name": "Nazwisko",
        "dob": "Data urodzenia",
        "dob-hint": "Format: DD.MM.RRRR",
        "search": "Szukaj",
        "confirm": "Tak, to ja",
        "found-title": "Znaleźliśmy Pana/Panią",
        "found-body": "Proszę potwierdzić, że chodzi o Pana/Panią.",
        "first-name-needed-title": "Proszę uzupełnić imię",
        "first-name-needed-body": "Abyśmy mogli jednoznacznie Pana/Panią znaleźć. Następnie proszę dotknąć „Szukaj”.",
        "ambiguous-title": "Nie udało się jednoznacznie Pana/Pani znaleźć",
        "ambiguous-body": "Proszę zapytać w recepcji – chętnie pomożemy.",
        "not-found-title": "Nie znaleziono pasujących danych",
        "not-found-body": "Proszę sprawdzić wprowadzone dane.",
        "error-title": "Wyszukiwanie jest teraz niemożliwe",
        "error-body": "Proszę spróbować ponownie lub zapytać w recepcji."
      },
      "create": {
        "insurance-question": "Jak jest Pan/Pani ubezpieczony/a?",
        "insurance-required": "Proszę wybrać rodzaj ubezpieczenia.",
        "error-title": "Nie udało się zapisać danych",
        "error-body": "Proszę spróbować ponownie lub zapytać w recepcji."
      }
    }
  },
  "onboarding": {
    "prepare": {
      "title": "Najpierw odblokuj",
      "subtitle": "FrontDesk+ musi być aktywowany w oprogramowaniu gabinetu.",
      "step1": "Zamów w SolStore (lub zamówienia Twojego partnera Doc-Cirrus za Ciebie).",
      "step2": "Po aktywacji aktywuj w inSuite w „inSuite Sols” (uprawnienia administratora).",
      "step3": "Otwórz administrację Bridge → „Dodaj urządzenie”.",
      "cta": "Wszystko gotowe – kontynuuj"
    },
    "welcome": {
      "title": "Dodaj to urządzenie do praktyki",
      "scan": "Zrób zdjęcie kodu",
      "prepare-link": "Brak kodu w inSuite?",
      "language": "Język"
    },
    "scan": {
      "requesting": "Prośba o dostęp do kamery…",
      "scanning": "Skieruj aparat na kod",
      "paste": "Zamiast tego wklej",
      "manual-title": "Połącz ręcznie",
      "manual-description": "Jeśli kod QR nie jest dostępny, pobierz dane połączenia od administracji Bridge.",
      "address-label": "Adres Bridge",
      "address-placeholder": "https://…/_rest_",
      "soltoken-label": "SOLTOKEN",
      "soltoken-placeholder": "Wstaw SOLTOKEN",
      "manual-submit": "Przejmij połączenie",
      "error-title": "Kod nie został rozpoznany",
      "camera-denied-title": "Odmowa dostępu do aparatu",
      "camera-denied-hint": "Zezwól na dostęp do aparatu w ustawieniach i spróbuj ponownie.",
      "retry": "Spróbuj ponownie"
    },
    "preflight": {
      "title": "Zostanie ustawione",
      "all-green": "Wszystkie testy zaliczone",
      "practice": "Praktyka",
      "device-name": "Nazwa urządzenia",
      "device-name-placeholder": "np. B. Recepcja 1",
      "card-reader": "Czytnik kart",
      "pin": "Nowy tajny numer",
      "pin-placeholder": "Czterocyfrowy PIN",
      "finish": "Skończyć",
      "recheck": "Sprawdź ponownie",
      "diagnosis": "Identyfikator diagnozy",
      "checklist-error": "Bridge odrzucił połączenie lub jest nieosiągalny. Sprawdź SOLTOKEN i adres Bridge.",
      "checklist-retry": "Sprawdź ponownie",
      "edit-token": "Zmień SOLTOKEN",
      "rescan": "Zeskanuj kod ponownie"
    },
    "persisting": "Zapisywanie konfiguracji …",
    "success": {
      "title": "Urządzenie dodane",
      "detail": "Urządzenie właśnie pojawiło się na komputerze stacjonarnym.",
      "starting": "Uruchamia się tryb pacjenta…"
    },
    "checklist": {
      "general_api_unavailable": {
        "label": "Połączenie z oprogramowaniem do ćwiczeń",
        "fix": "Bridge Sprawdź połączenie i adres serwera."
      },
      "missing_insuite_url": {
        "label": "Adres inSuite",
        "fix": "Zeskanuj ponownie kod QR - brakuje adresu."
      },
      "missing_server_token": {
        "label": "Token serwera",
        "fix": "Zeskanuj ponownie kod QR - brakuje tokena."
      },
      "missing_gateway_session": {
        "label": "Sesja Gateway",
        "fix": "Zaloguj się ponownie — brakuje sesji."
      },
      "missing_gateway_enrollment": {
        "label": "Rejestracja urządzenia",
        "fix": "Zarejestruj urządzenie w Gateway."
      },
      "gateway_not_ready": {
        "label": "Gotowość Gateway",
        "fix": "Poczekaj, aż Gateway zakończy konfigurację."
      },
      "token_verification_failed": {
        "label": "Kontrola tokena",
        "fix": "Sprawdź token serwera lub połączenie Bridge."
      },
      "session_expired": {
        "label": "spotkanie",
        "fix": "Sesja wygasła - zaloguj się ponownie."
      },
      "device_revoked": {
        "label": "Stan urządzenia",
        "fix": "To urządzenie zostało zablokowane. Skontaktuj się z praktyką."
      },
      "missing_practice_name": {
        "label": "Nazwa praktyki",
        "fix": "Nie można wczytać nazwy gabinetu lekarskiego (inSuite)."
      },
      "missing_device_name": {
        "label": "Nazwa urządzenia",
        "fix": "Proszę wprowadzić nazwę urządzenia."
      },
      "telematik_unavailable": {
        "label": "Infrastruktura telematyczna",
        "fix": "Opcjonalnie — sprawdzenie karty jest możliwe, gdy tylko TI będzie dostępny."
      },
      "selected_card_reader_unavailable": {
        "label": "Czytnik kart",
        "fix": "Opcjonalnie — wybierz lub podłącz czytnik kart."
      },
      "medical_card_unavailable": {
        "label": "SMC-B / HBA",
        "fix": "Opcjonalnie — włóż kartę uwierzytelniającą praktyki lekarskiej (SMC-B)."
      }
    },
    "token": {
      "title": "Wprowadź SOLTOKEN",
      "description": "Ze względów bezpieczeństwa kod QR nie zawiera SOLTOKEN. Skopiuj go w inSuite w sekcji „Sol-Aktivierung” (FrontDesk+) i wklej tutaj.",
      "submit": "Dalej",
      "rescan": "Zeskanuj kod ponownie"
    }
  }
}
